import { setCookie, getCookie, removeCookie } from './session';
import { get } from 'lodash';

export const signIn = data => {
  setCookie(process.env.REACT_APP_KEY, data);
};

export const getAuthorizationToken = () => {
  const data = getCookie(process.env.REACT_APP_KEY);
  return get(data, 'hooliToken', '')

};

export const getSessionId = () => {
  const data = getCookie(process.env.REACT_APP_KEY);
  return get(data, 'sessionId', '')

};

export const getUserLogged = () => {
  const data = getCookie(process.env.REACT_APP_KEY);

  return {
    usuarioApellidos: get(data, 'usuarioApellidos', ''),
    usuarioNombres: get(data, 'usuarioNombres', ''),
    usuarioId: get(data, 'usuarioId', ''),
    roles: get(data, 'roles', []),
  };
};

export const signOut = () => {
  removeCookie(process.env.REACT_APP_KEY);
};

export const buildErrorsObj = (err) => {
  let serverErrors = get(err, 'message', '') || get(err, 'statusText', '') || 'ERROR';
  const errNro = get(err, 'errNro', '');
  if (errNro !== '') {
    serverErrors = `${errNro} - ${serverErrors}`;
  }
  return {
    serverErrors,
    statusError: get(err, 'status', '')
  }
};

/*
TODO
- Falta mostrar un error en el login
- Redirccionar al login cuando de unauthorized
*/



// WEBPACK FOOTER //
// ./src/utils/auth.js